module.exports = __webpack_public_path__ + "static/media/view.37f206ff.svg";